var _ = require('underscore');
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="banner-center">\n    <div class="banner-content">\n        ';
 if (data.options.close_button) { 
__p+='\n            <div class="banner-close glyph-close glyph-center">&nbsp;</div>\n        ';
 } 
__p+='\n        <div class="message-content"></div>\n    </div>\n</div>\n';
return __p;
};
